import {
  IInputBase,
  IInputHint,
  IInputLabel,
  IInputWrapper,
} from 'interfaces/forms/_base';
import { IKeyUpEvent } from 'interfaces/forms/event';
import { RadixTextFieldSize, RadixTextType } from 'lib_ts/enums/radix-ui';
import { ReactNode } from 'react';

export interface ITextBase {
  // todo: rename this to defaultValue
  value?: string;

  maxLength?: number;

  readOnly?: boolean;

  monospace?: boolean;

  onChange?: (value: string | undefined) => void;

  // provide as a positive number to aggregate keystrokes before triggering change prop function(s)
  debounceMs?: number;
}

export enum RegexFilter {
  Alpha,
  AlphaNumeric,
  Numeric,
  Whitespace,
}

export interface ITextInput
  extends IInputBase, ITextBase, IInputLabel, IInputHint, IInputWrapper {
  type?: RadixTextType;

  regex?: RegexFilter;

  // callbacks
  onKeyUp?: (event: IKeyUpEvent) => void;
  onNumericChange?: (value: number) => void;
  onFloatChange?: (value: number | string) => void;
  onOptionalNumericChange?: (value: number | undefined) => void;

  // e.g. for username and password fields that need to be detected by browsers
  controlId?: string;
  // e.g. for username and password fields that need to be detected by browsers
  autoComplete?: string;

  size?: RadixTextFieldSize;

  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
}

export interface ITextareaInput
  extends ITextBase, IInputBase, IInputLabel, IInputHint, IInputWrapper {
  rows?: number;

  showCopyButton?: boolean;
}
